export const PRINTABLE_ROUTES = [
  'dashboard',
];

export function checkPrintableRoute(loc) {
  const bodyElement = document.getElementById('body');

  if (PRINTABLE_ROUTES.indexOf(loc) > -1) {
    bodyElement.classList.remove('hidden-print');
  } else {
    if (!bodyElement.classList.contains('hidden-print')) {
      bodyElement.classList.add('hidden-print');
    }
  }
}
